
import {useState,useEffect} from 'react'
import {useNavigate , useLocation} from "react-router-dom";
import SendData from "./SendData"
import Switch from "./components/Switch"

import socket from './../socket.js'

function Modal ({titr,items,onChange,onClose}){
  return (
    <div className="modal"  /*style={overlayerStyle}*/>
      <h2 style={{textAlign:'center'}} >
        {titr}
      </h2>
      {items}
    </div>
  );
}

const overlayerStyle = {
  position:'fixed',
  top:0,
  left:0,
  right:0,
  bottom:0,
  background: "rgba (0,0,0,0,5)",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex:1000
};

const modalStyle = {
  background: '#fff',
  padding:20,
  borderRadius:8,
  width:'80%',
  maxWidth:300
};



function TimeSetting (){
  const location = useLocation ();
//  const [name,setName] = useState (/*location.state.name*/);

  const [times,setTimes] = useState (location.state);
  const [select,setSelect] = useState (-1);
  const [modalShow,setModalShow] = useState (false);
  const [name,setName] = useState ("");
  const [start,setStart] = useState ("");
  const [end,setEnd] = useState ("");
  const [modalShow_delete,setModalShow_delete] = useState (false);

  const navigate = useNavigate ();
  useEffect (()=>{

  return () =>{
    socket.off ('message');
  };
},[socket]);

  return (
    <div style={style.container}>
    {
      modalShow_delete && (
    <Modal
      titr={'آیا میخواهید ساعت \n'
                      +'  '+times[select].start+':00'+'  '+
                      'الی '
                      +'  '+times[select].end+':00'+'  \n'+

                      'را حذف نمایید'}
      items={
        <div>
          <div style={{flex:1}}  className="row"  >
          <button   className='btn'
            onClick={()=>{
              var a=times; a.splice(select, 1); setTimes (a); setSelect (-1);
              SendData (socket,'data',{
                "event":"set_times",
                "data":a
              });
              setModalShow_delete (false)
            }} >
            بله
          </button>
          <button   className='btn'
            onClick={()=>{
              setModalShow_delete (false)
            }} >
            خیر
          </button>
          </div>

          </div>
      }
     /> )}


     {
       modalShow && (
     <Modal
       titr=""
       items={
         <div style={{ margin:10,padding:10, borderRadius:10 , backgroundColor:'white' , }}>
         <div className='row' style = {{flexDirection:'row',marginTop:10 }}>
         <input style={{margin:10,padding:5,fontSize:20, flex:.5,width:"100%",borderRadius:4,textAlign:'center'}}
         type="text"
         placeholder = ""
         value={name}
         onChange = {(e)=>{setName (e.target.value)}}/>
         <h2 style={{ fontSize:24 , alignSelf:'center' ,margin:2 , flex:.5 }} >عنوان </h2>

         </div>
         <div className='row'  style = {{flexDirection:'row' , marginTop:10}}>
           <input style={{margin:10,padding:5,fontSize:20, flex:.5,width:"100%",borderRadius:4,textAlign:'center'}}
           type="tel"
           placeholder = ""
           value={start}
           onChange = {(e)=>{setStart (e.target.value)}}/>
           <h2 style={{ fontSize:24 , alignSelf:'center' ,margin:2 , flex:.5 }} >از ساعت </h2>

         </div>
         <div  className='row'  style = {{flexDirection:'row',marginTop:10 }}>
           <input style={{margin:10,padding:5,fontSize:20, flex:.5,width:"100%",borderRadius:4,textAlign:'center'}}
           type="tel"
           placeholder = ""
           value={end}
           onChange = {(e)=>{setEnd (e.target.value)}}/>
           <h2 style={{ fontSize:24 , alignSelf:'center' ,margin:2 , flex:.5 }} >تا ساعت </h2>

         </div>
           <div className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row'  }}>
           <div  style={{ margin:10  ,flex:.5 }}>
           <button className='btn'
              onClick={() => {
                if (name.length<2 || name.length>16)window.alert ('عنوان باید بیشتر از 2 و کمتر از 16 حرف باشد');
                else if (start>24 || start<0)window.alert ('زمان باید بین 0 الی 24 باشد');
                else if (end>24 || end<0)window.alert ('زمان باید بین 0 الی 24 باش');
                else
                {
                  if (select>=0)
                  {
                    var a=times;
                    a[select].name=name+'';
                    a[select].start=start+'';
                    a[select].end=end+'';
                 //   setTimes (a);
                  }else {
                    var a=times;
                    a.push ({'name':name , 'start':start ,'end':end});
                 //   setTimes (a);
                  }
                  SendData (socket,'data',{"event":"set_times",data:a});
                  setModalShow (false);
               }
              }}
              >
              تایید
              </button>
            </div>
            <div  style={{ margin:10  ,flex:.5 }}>
            <button  className='btn' style={{fontSize:20,flex:.4,margin:10}}
                 onClick={() => { setModalShow (false); }}
              >
              کنسل
              </button>
              </div>
           </div>
         </div>

       }
      /> )}




      <div style={style.content}>
        <h2 style={style.text}>
        زمان بندی تنظیمات
        </h2>


    <div style={{backgroundColor:'white',padding:10}}>
    {

      times.map( (value,key) => {
         return (
           <div  key={key} style={{borderRadius:10, backgroundColor:(select==key)?'#09f':'#00f0',justifyContent: 'space-between', flex:1, padding:5 ,flexDirection:'row' }}
             onClick={()=>{
               setSelect (key);
             }}
           >
           <h2 style={{color:(select==key)?'white':'#09f', fontSize:20,flex:.5, fontStyle: "italic",textAlign:"center" }}>
           {
             value.name+' - '+
             'از ساعت '+
             value.start+':00'+
             ' الی '+
             value.end+':00'
           }
           </h2>

           </div>
         )

       })
     }
     </div>

     </div>


     <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row' ,flex:1 }}>
     <div  style={{ margin:10  ,flex:1/3 }}>
     <button className="btn"
        title="افزودن"
        onClick={() => {
          if (times.length>=10) window.alert ('افزودن بیش از 10 مورد امکان پذیر نمیباشد');
          else {
           setSelect (-1);
           setName ('')
           setStart ('');
           setEnd ('');
           setModalShow (true);
         }
       }}
        >
        افزودن
        </button>
      </div>
      <div  style={{ margin:10  ,flex:1/3 }}>
      <button className="btn" style={{fontSize:20,flex:.4,margin:10}}
           title="ویرایش"
           onClick={() => { if (select>=0){
                 setName (times[select].name);
                 setStart (times[select].start);
                 setEnd (times[select].end);
                 setModalShow (true);
               }}}
        >
        ویرایش
        </button>
        </div>
        <div  style={{ margin:10  ,flex:1/3  }}>
      <button className="btn" style={{fontSize:20,flex:.2,margin:10}}
              title="حذف"
              onClick={() => {
                if (select>=0)
                  setModalShow_delete (true);
              }}
        >
        حذف
        </button>
        </div>
    </div>







    <button className="btn"
      onClick ={()=>{
        if (select>=0)
        {
          socket.off ('message');
          socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="MENU_TIME")navigate ("/MenuTimeSetting",{state:JSON.parse(data).data});
          });
          SendData (socket,'data',{"event":"get_menu_time" , "id":select+''});
       }

      }}>
      تنظیمات
    </button>
    </div>
  );


}
const style={
  container:{
    width:"90%",
    minHeight:"100vh",
//    display:"flex",
    alignItems:"center",
    padding:10,

//    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
     maxWidth:820,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10,
    padding:10,
    backgroundColor:"#00afff",
    borderRadius:8
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:20,
    borderRadius:8,
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:820,
    padding:4,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
    padding:0,
    margin:10,
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default TimeSetting;
